import { BeckyFunctionLibrary, BeckyRequestPayload } from '../../types/becky'
import { ModuleFetcher } from '@wix/thunderbolt-becky-types'
import { decodeModulesToLoad } from '@wix/thunderbolt-commons'
import moduleResolverFactory from './moduleResolverFactory'
import { variantSeparator } from '../../carmi/variants/constants'

const resolveWidgetsToLoad = (payload: BeckyRequestPayload, widgetIdsOnPage: Array<string> = []) => {
	const allWidgetsOnSite = decodeModulesToLoad(payload.ooiVersions || '')
	return allWidgetsOnSite.filter((w) => widgetIdsOnPage.find((widgetId) => widgetId === w.id))
}

function processOoiCssFactory(resolveModule: (id: string) => any, options: { isMobile: boolean; isRTL: boolean }) {
	return (
		widgetId: string,
		styleData: any,
		{ prefixSelector, withStaticCss = true }: { prefixSelector: string; withStaticCss?: boolean }
	): string => {
		const { cssConfig } = resolveModule(widgetId) || {}
		if (!cssConfig) {
			return ''
		}
		// can't use typescript import due to jest transfer exploding when looking into tpa-style-webpack-plugin (and es6 module)
		const {
			getProcessedCssWithConfig,
			getStaticCssWithConfig,
		} = require('@wix/tpa-style-webpack-plugin/standalone')
		const [originalPrefixSelector] = prefixSelector.split(variantSeparator)
		const { siteColors, siteTextPresets, style: styleParams } = styleData
		const staticCss = withStaticCss ? getStaticCssWithConfig(cssConfig, { prefixSelector: '' }) : ''
		return (
			getProcessedCssWithConfig(
				cssConfig,
				{
					siteColors,
					siteTextPresets,
					styleParams,
				},
				{
					...options,
					prefixSelector: originalPrefixSelector,
				}
			) + staticCss
		)
	}
}

export const processOoiCssImpl = async (
	{ widegtsIds, ...options }: { widegtsIds?: Array<string>; isMobile: boolean; isRTL: boolean },
	{
		funcLib: { runAsyncAndReport },
		moduleFetcher,
		payload,
	}: {
		payload: BeckyRequestPayload
		funcLib: BeckyFunctionLibrary
		moduleFetcher: ModuleFetcher
	}
) => {
	const widgetsToLoad = resolveWidgetsToLoad(payload, widegtsIds)
	const resolveModule = await moduleResolverFactory(widgetsToLoad, {
		moduleFetcher,
		runAsyncAndReport,
	})
	return processOoiCssFactory(resolveModule, options)
}
